import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { StateCacheService } from '../../core/services/state-cache.service';

@Pipe({
  name: 'workGroupName'
})
export class WorkGroupNamePipe implements PipeTransform {

  constructor(
    private stateCacheSvc: StateCacheService
  ) { }
  transform(id?: number | null): Observable<string> {
    return this.stateCacheSvc.getWorkGroup(id).pipe(
      map(p => p ? `${p.name}` : '')
    );
  }

}
